import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

import {

} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Set a component's draft memory options
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestSetComponentMemoryOptions = packet => {
  return {
    type: 'REQUEST_SET_COMPONENT_MEMORY_OPTIONS',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveSetComponentMemoryOptionsSuccess = data => ({
  type: 'RECEIVE_SET_COMPONENT_MEMORY_OPTIONS_SUCCESS',
  data
})

export const receiveSetComponentMemoryOptionsFail = data => ({
  type: 'RECEIVE_SET_COMPONENT_MEMORY_OPTIONS_FAIL',
  data
})

export const tryToSetComponentMemoryOptions = packet => (dispatch, getState) => {

  dispatch(requestSetComponentMemoryOptions(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;
  return fetch('/api/components/draft/memory-options/' + packet.id, {
      method: 'put',
      body: JSON.stringify(packet),
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveSetComponentMemoryOptionsSuccess(json));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveSetComponentMemoryOptionsFail({errors:e, lastSubmit: packet}));
    })
}
